import React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import LanguageSelectStore from '@src/business-components/common-language-select/store';
const styles = require('./index.less');
/**
 * 语言选择器
 * @param store {LanguageSelectStore}
 * @param {string} buttonType -按钮样式 nav为图标按钮，footer为文字按钮
 * @param {string} displayPosition -语言选择框展示位置 above为上方，below为下方
 * @returns {JSX.Element}
 * @constructor
 */
const LanguageSelect = ({ store, buttonType = 'nav', displayPosition = 'below' }) => {
  store.use();

  const styleName = {
    nav: styles.root_mini,
    footer: styles.root
  };
  const btnPosition = {
    below: styles.show_below,
    above: styles.show_above
  };
  const renderBtn = () => {
    if (buttonType === 'footer') {
      return (
        <div className={cx(styles.btn_display_footer, store.isExpand && styles.btnActive)} onClick={store.onLanguageBtnClick}>
          <div className={styles.language_btn_word}>{store.currentLanguageObject?.language}</div>
          <div className={styles.language_btn_arrow} />
        </div>
      );
    } else {
      return <div className={styles.btn_display_nav} onClick={store.onLanguageBtnClick} />;
    }
  };
  return (
    <div className={styleName[buttonType]} id={'languageSelector'}>
      {renderBtn()}
      <div className={cx(
        buttonType === 'footer' ? styles.expand_container_footer : styles.expand_container_nav, 
        btnPosition[displayPosition], 
        store.isExpand && styles.isExpand
      )}>
        <div className={styles.expand_container_box}>
          {store.languageList.map((item, index) => {
            const isSelected = store.currentLanguageObject?.language === item.language;
            return (
              <div
                className={cx(
                  styles.expand_content,
                  isSelected && styles.isSelect
                )}
                key={index}
                onClick={() => {
                  store.onLanguageSelected(item.languageKey);
                }}
              >
                <div className={cx(
                  styles.expand_word,
                  isSelected && styles.expand_word_selected
                )}>
                  {item.language}
                </div>
                <div className={cx(
                  styles.expand_tickIcon,
                  isSelected && styles.expand_tickIcon_selected
                )} />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default wrapStore(LanguageSelect, LanguageSelectStore);
